module.exports = __webpack_public_path__ + "img/32ne.541d5d66.svg";